import React from 'react'
import s from './listLink.module.css'
import { LinkOut } from '../../svg/link_out'
// import { GTMEvents } from '../../lib/GTMevents'

const ListLink = props => {
  return (
    <a
      onClick={props.event}
      href={props.link}
      target="_blank"
      className={`${s.listLinkItem} ${props.className} bg-white border-1 border-gray-0 brad-3 flex items-center justify-between tw-py-4 tw-py-6@lg tw-px-4 tw-px-6@lg tw-my-4`}
    >
      <span
        className={`w-80 font-family-secondary c-gray--4 ${
          props.underline ? 'underline' : ''
        } ${props.bold ? 'fw-7' : 'fw-6'} tw-f-14 tw-f-16@lg`}
      >
        {props.title}
      </span>
      <span className="w-20 right cursor-pointer tw-ml-2">
        <LinkOut height={24} width={24} fill={props.icoColor} />
      </span>
    </a>
  )
}

ListLink.defaultProps = {
  title: '', // Titulo
  link: '', // Link
  icoColor: '#45494E', // Color del icono
  className: '', // Clase CSS
  underline: false, // Subrayado del titulo
  bold: true, // Negrita al titulo
  GTMOption: { section: '', sub_section: '', option: '', location: '' },
  event: () => {},
}

export default ListLink
